<div
  [reactComponent]="DiscoverTilesComponent$"
  [props]="{tiles,options:discoverTilesOptions,businessVertical:'groceries',onTileToggle: onTileToggleCallBack}"
></div>
<button class="css-loader-button" mat-icon-button></button>
